import { $post, $get } from '@/api/request'
import base from '@/utils/index'
import axios from 'axios'

const baseFunc = base()
// import axios from 'axios'
// 登陆获取验证码
export function getCaptcha(data) {
  return $post({
    url: '/userInfo/getCaptcha',
    data
  })
}
// 登录
export function login(data) {
  return $post({
    url: '/userInfo/login',
    data
  })
}
// 登出
export function loginOut(data) {
  return $post({
    url: '/userInfo/logout',
    data
  })
}
// 上传文件
export function uploadFile(data) {
  return $post({
    url: '/minio/fileUpload',
    data
  })
}
// 查询部门列表
export function listDeptNameList(data) {
  return $post({
    url: '/userInfo/listDeptName',
    data
  })
}
// 绑定token和公司ID
export function bindTokenCompanyIdAfterLogin(data) {
  return $post({
    url: '/userInfo/bindTokenCompanyIdAfterLogin',
    data
  })
}
// 分页查询用户列表(审核人选择专用，为了避开数据隔离)
export function pageListUserlnfoForAudit(data) {
  return $post({
    url: '/userInfo/pageListUserInfoForAudit',
    data
  })
}
// 
export function getPreviewUrl(data) {
  return $get({
    url: `/minio/preview?fileName=${data}`,
    data
  })
}
// 下载文件
export function fileDownload(data, type = '') {
  let url = process.env.VUE_APP_BASE_API + '/minio/fileDownload?fileName=' + data
  console.log(url, 'urlurlurl');
  let params = {
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: {
      Authorization: baseFunc.getLocalStorage('token'),
    }
  };
  if (type === 'xls') {
    params.responseType = "arraybuffer";
    params.headers['Content-Type'] = "application/vnd.ms-excel;application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  } else if (type === 'doc') {
    // bolb 走默认
  }

  return new Promise((resolve, reject) => {
    axios.get(url, params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 下载未存放的pdf
export function downloadPdf(data, type = '') {
  const { url = '' } = data
  let params = {
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: {
      Authorization: baseFunc.getLocalStorage('token'),
    }
  };
  if (type === 'xls') {
    params.responseType = "arraybuffer";
    params.headers['Content-Type'] = "application/vnd.ms-excel;application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  } else if (type === 'doc') {
    // bolb 走默认
  }
  return new Promise((resolve, reject) => {
    axios.get(url, params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
